import { makeElementCreator } from '@qdabra/build-xml';
import { nsD, nsDfs, nsPc, nsQ } from '@qdabra/forms-shared/xmlNamespaces';
import { namespaceCmeData } from '../formsviewer/constants.namespaces';

export const makeNoNsElement = makeElementCreator();

export const makeCmeElement = makeElementCreator(namespaceCmeData, 'my');

export const makeDElement = makeElementCreator(nsD, 'd');

export const makeDfsElement = makeElementCreator(nsDfs, 'dfs');

export const makePcElement = makeElementCreator(nsPc, 'pc');

export const makeQElement = makeElementCreator(nsQ, 'q');
